import { render, staticRenderFns } from "./access-registration.vue?vue&type=template&id=1c1942aa&scoped=true&lang=pug"
import script from "./access-registration.vue?vue&type=script&lang=js"
export * from "./access-registration.vue?vue&type=script&lang=js"
import style0 from "./access-registration.vue?vue&type=style&index=0&id=1c1942aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1942aa",
  null
  
)

export default component.exports